(() => {
  const fieldDefs = [
    ['Vorname','first',true],['Name','last',true],['Strasse und Hausnummer','street',true],
    ['PLZ','zip',true],['Wohnort','city',true],['Geburtsdatum','dob',false],['Führerausweisnummer','licence',false]
  ];
  function init(root) {
    if (root.dataset.initialized) return;
    const form = document.getElementById(root.dataset.formId);
    const section = root.closest('product-info');
    const quantity = section?.querySelector(`#Quantity-${CSS.escape(root.dataset.sectionId)}`);
    if (!form || !quantity) { console.warn('KT: Produktformular oder Mengenfeld fehlt.'); return; }
    root.dataset.initialized = 'true';
    const list = root.querySelector('[data-kt-list]');
    const add = root.querySelector('[data-kt-add]');
    const counter = root.querySelector('[data-kt-counter]');
    const error = root.querySelector('[data-kt-error]');
    const max = Number(root.dataset.max) || 4;
    let count = 0;
    function field(number, [label,key,required]) {
      const wrap = document.createElement('div');
      wrap.className = 'kt-participant__field' + (key === 'street' || key === 'licence' ? ' kt-participant__field--wide' : '');
      const id = `kt-${root.dataset.sectionId}-${number}-${key}`;
      const lab = document.createElement('label'); lab.htmlFor = id; lab.textContent = label + (required ? ' *' : ' (optional)');
      const input = document.createElement('input'); input.id = id;
      input.name = `properties[Teilnehmer ${number} – ${label}]`;
      input.type = key === 'dob' ? 'date' : 'text';
      input.required = required;
      input.maxLength = key === 'licence' ? 80 : 150;
      input.autocomplete = 'off';
      wrap.append(lab,input);return wrap;
    }
    function create(number) {
      const details = document.createElement('details'); details.className = 'kt-participant'; details.dataset.participant = number;
      const summary = document.createElement('summary'); summary.textContent = `TeilnehmerIn ${number}`;
      const fields = document.createElement('div'); fields.className = 'kt-participant__fields';
      fieldDefs.forEach(def => fields.append(field(number,def)));
      details.append(summary,fields); return details;
    }
    function setCount(next, source='ui') {
      next = Math.max(1,Math.min(max,Math.trunc(Number(next) || 1)));
      if (next < count) {
        const removed = [...list.querySelectorAll('.kt-participant')].slice(next);
        const hasData = removed.some(card => [...card.querySelectorAll('input')].some(input => input.value.trim()));
        if (hasData && !window.confirm('Die Angaben der entfernten TeilnehmerInnen gehen verloren. Fortfahren?')) {
          quantity.value = count;quantity.dispatchEvent(new Event('change',{bubbles:true}));return;
        }
      }
      while (count < next) { count++;list.append(create(count)); }
      while (count > next) { list.lastElementChild.remove();count--; }
      counter.textContent = `${count} von ${max}`; add.hidden = count >= max;
      if (Number(quantity.value) !== count) {
        quantity.value = count;
        quantity.dispatchEvent(new Event('change',{bubbles:true}));
      }
      error.hidden = true;
    }
    add.addEventListener('click',()=>setCount(count+1));
    quantity.addEventListener('change',()=>setCount(quantity.value,'quantity'));
    // Capture validation before Refresh's product-form submit handler processes FormData.
    form.addEventListener('submit', event => {
      error.hidden = true;
      for (const card of list.querySelectorAll('.kt-participant')) {
        for (const input of card.querySelectorAll('input[required]')) {
          input.setAttribute('aria-invalid', String(!input.value.trim()));
          if (!input.value.trim()) {
            event.preventDefault();event.stopImmediatePropagation();
            card.open = true;
            error.textContent = 'Bitte füllen Sie alle Pflichtfelder für sämtliche TeilnehmerInnen aus.';
            error.hidden = false;
            input.focus();return;
          }
        }
      }
      if (Number(quantity.value) !== count) {
        event.preventDefault();event.stopImmediatePropagation();
        error.textContent = 'Die Anzahl der Kursplätze stimmt nicht mit der Teilnehmerzahl überein.';
        error.hidden = false;
      }
    },true);
    setCount(quantity.value);
  }
  function boot() { document.querySelectorAll('[data-kt-participants]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
